import React, { useState, useEffect } from "react";
import { Segment, Header, Button } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import SchedaAllievoPrivateNew from "./SchedaAllievoPrivateNew";

const Step4 = ({
  onPrevious,
  onFinish,
  numPupils,
  datiAllievi,
  setDatiAllievi,
  livelli,
}) => {
  const [errorsAllievi, setErrorsAllievi] = useState(() => {
    const errorsArray = [];
    for (let i = 0; i < 5; i++) {
      errorsArray.push({});
    }
    return errorsArray;
  });

  const livelliArray = Object.keys(livelli).map((id) => {
    const x = livelli[id];
    return {
      key: id,
      text: x.text,
      img: require(`../../assets/images/livelli/${x.simbolo}.jpg`),
      infoString: x.descrizione ?? "No description available",
    };
  });

  const opzioniSesso = [
    {
      key: "M",
      text: "M",
      img: require(`../../assets/images/people/Male2.jpg`),
    },
    {
      key: "F",
      text: "F",
      img: require(`../../assets/images/people/Female2.jpg`),
    },
  ];

  const { t } = useTranslation();

  const onAllievoChange = (index, field, value) => {
    const updatedAllievi = [...datiAllievi];
    updatedAllievi[index - 1][field] = value;
    setDatiAllievi(updatedAllievi);
  };

  // Validation function for pupils
  const areAllPupilsValid = () => {
    return datiAllievi
      .slice(0, Number(numPupils))
      .every(
        (a) =>
          a &&
          typeof a.nome === "string" &&
          a.nome.trim().length >= 2 &&
          typeof a.cognome === "string" &&
          a.cognome.trim().length >= 2 &&
          a.anno !== undefined &&
          a.anno !== null &&
          a.anno !== ""
      );
  };

  return (
    <Segment>
      <Header as="h3">{t("dati_allievi") || "Programma Lezioni"}</Header>

      {Array.from({ length: numPupils }).map((_, idx) => (
        <SchedaAllievoPrivateNew
          key={idx}
          t={t}
          num={idx + 1}
          datiAllievo={datiAllievi[idx]}
          errors={errorsAllievi[idx]}
          opzioniSesso={opzioniSesso}
          onFieldChange={onAllievoChange}
        />
      ))}

      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Button
          color="green"
          disabled={!areAllPupilsValid()}
          onClick={() => {
            onFinish();
          }}
        >
          Add to cart
        </Button>
      </div>
    </Segment>
  );
};
export default Step4;
